import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioDirective } from './radio.directive';
import { RadioLabelDirective } from './radio-label/radio-label.directive';
import { RadioComponent } from './radio.component';
import { RadioGroupComponent } from './radio-group.component';
import { RadioGroupLabelDirective } from './radio-group-label/radio-group-label.directive';

@NgModule({
  declarations: [
    RadioDirective,
    RadioLabelDirective,
    RadioComponent,
    RadioGroupComponent,
    RadioGroupLabelDirective,
  ],
  imports: [CommonModule],
  exports: [
    RadioDirective,
    RadioLabelDirective,
    RadioComponent,
    RadioGroupComponent,
    RadioGroupLabelDirective,
  ],
})
export class RadioModule {}
